import { render, staticRenderFns } from "./PurchaseOrderDetailList.vue?vue&type=template&id=182d3ac0&"
import script from "./PurchaseOrderDetailList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports